<template>
	<div style="display: flex;flex-direction: column;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="isDataLoading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<el-descriptions :title="$t('language000093')" style="padding: 20px; " direction="vertical" :column="4" border>
			<el-descriptions-item :label="$t('language000092')">
				<a :href="data.avatar" target="_blank">
					<img :src="data.avatar" :alt="data.avatar" style="width: 44px; height: auto;" />
				</a>
			</el-descriptions-item>
			<el-descriptions-item :label="$t('language000094')">{{ data.nickName }}</el-descriptions-item>
			<el-descriptions-item :label="$t('language000095')">{{ data.userId }}</el-descriptions-item>
			<el-descriptions-item :label="$t('language000096')">{{ data.phoneNumber }}</el-descriptions-item>
		</el-descriptions>

		<!-- 列表 -->
		<el-table v-if="tableData" :data="tableData" height="180" stripe border
			style="width: 100%; flex: 1; overflow: auto;">
			<el-table-column type="index" :index="indexMethod"></el-table-column>

			<el-table-column prop="name" :label="$t('language000083')" align="center" width="150"></el-table-column>

			<el-table-column prop="number" :label="$t('language000084')" align="center" width="180"></el-table-column>
			<el-table-column prop="numberEn" :label="$t('language000084')" align="center" width="180"></el-table-column>

			<el-table-column prop="price" :label="$t('language000085')" align="center"></el-table-column>

			<el-table-column fixed="right" :label="$t('language000086')" width="100" align="center">
				<template slot-scope="scope">
					<el-button @click="payment(scope.$index)" type="text"
						size="small">{{ $t('language000082') }}</el-button>
				</template>
			</el-table-column>

		</el-table>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				isDataLoading: false, //加载数据提示框
				tableData: [], //数据
				image: "", //用户头像
				data: '', //接口返回的数据
			};
		},
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			//alert(userLanguage);
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			// 如果语言受支持，则设置为用户语言，否则设置为默认语言
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;

			// 解析传递过来的 JSON 字符串
			this.data = JSON.parse(this.$route.query.data);
			this.data.avatar = this.$p_urlImage + this.data.avatar;
			console.log("解析传递过来的：", this.data);

			this.fetchData();
		},
		methods: {
			fetchData() {
				this.tableData = [{
						name: '月卡',
						priceId: 'price_1Q287uCQOGOFHFAnmJCfnt0X',
						priceId_formal: 'price_1Q28A3CQOGOFHFAnbbT7RjhI',
						number: '一个月的VIP',
						numberEn: 'One month VIP',
						price: "5 USD",
					}, {
						name: '季卡',
						priceId: 'price_1Q288OCQOGOFHFAnIER4uy4p',
						priceId_formal: 'price_1Q28A2CQOGOFHFAn4V0aaHOp',
						number: '3个月的VIP',
						numberEn: 'Three months VIP',
						price: "13 USD",
					}, {
						name: '年卡',
						priceId: 'price_1Q288uCQOGOFHFAnLg5utckX',
						priceId_formal: 'price_1Q289zCQOGOFHFAnreyvc2Oq',
						number: '一年的VIP',
						numberEn: 'One year VIP',
						price: "48 USD",
					}, {
						name: 'QIUI币 01',
						priceId: 'price_1Q27fICQOGOFHFAnkf1ot8cZ',
						priceId_formal: 'price_1Q27xxCQOGOFHFAnWO6csqLf',
						number: '6个QIUI币',
						numberEn: '6 QIUI coins',
						price: "1 USD",
					}, {
						name: 'QIUI币 02',
						priceId: 'price_1Q27hjCQOGOFHFAnMTzsER0Z',
						priceId_formal: 'price_1Q28AOCQOGOFHFAnbZ3Z6J7S',
						number: '18个QIUI币',
						numberEn: '18 QIUI coins',
						price: "3 USD",
					}, {
						name: 'QIUI币 03',
						priceId: 'price_1Q27irCQOGOFHFAnfGGuaoGD',
						priceId_formal: 'price_1Q28ALCQOGOFHFAnDbXTk0mB',
						number: '30个QIUI币',
						numberEn: '30 QIUI coins',
						price: "5 USD",
					}, {
						name: 'QIUI币 04',
						priceId: 'price_1Q27ptCQOGOFHFAn6rhtSFWA',
						priceId_formal: 'price_1Q28AJCQOGOFHFAnLN21jbGd',
						number: '60个QIUI币',
						numberEn: '60 QIUI coins',
						price: "10 USD",
					}, {
						name: 'QIUI币 05',
						priceId: 'price_1Q27xDCQOGOFHFAnpez4Y3Di',
						priceId_formal: 'price_1Q28AHCQOGOFHFAnrp3KAdy8',
						number: '120个QIUI币',
						numberEn: '120 QIUI coins',
						price: "20 USD",
					}, {
						name: 'QIUI币 06',
						priceId: 'price_1Q282GCQOGOFHFAnhPYi5Nbc',
						priceId_formal: 'price_1Q28AGCQOGOFHFAnLLbzzmoM',
						number: '204个QIUI币',
						numberEn: '204 QIUI coins',
						price: "34 USD",
					}, {
						name: 'QIUI币 07',
						//priceId: 'price_1Q282zCQOGOFHFAn0UbKnUE5',
						//priceId_formal: 'price_1Q28AECQOGOFHFAnx8aYyp4I',
						priceId: 'price_1QUJ7PCQOGOFHFAnvsnNkk13',
						priceId_formal: 'price_1QUIvxCQOGOFHFAndo8B5Qzu',
						number: '240个QIUI币',
						numberEn: '240 QIUI coins',
						price: "40 USD",
					}, {
						name: 'QIUI币 08',
						priceId: 'price_1Q284DCQOGOFHFAnvepYvuDL',
						priceId_formal: 'price_1Q28ACCQOGOFHFAnQYNiogZZ',
						number: '330个QIUI币',
						numberEn: '330 QIUI coins',
						price: "55 USD",
					}, {
						name: 'QIUI币 09',
						priceId: 'price_1Q284uCQOGOFHFAn7cmKB9xI',
						priceId_formal: 'price_1Q28AACQOGOFHFAnb0qfwsD7',
						number: '528个QIUI币',
						numberEn: '528 QIUI coins',
						price: "88 USD",
					}, {
						name: 'QIUI币 10',
						priceId: 'price_1Q2866CQOGOFHFAnrZEpzdus',
						priceId_formal: 'price_1Q28A8CQOGOFHFAnz3RQeYqT',
						number: '666个QIUI币',
						numberEn: '666 QIUI coins',
						price: "110 USD",
					}, {
						name: 'QIUI币 11',
						priceId: 'price_1Q286nCQOGOFHFAno9LMQNRE',
						priceId_formal: 'price_1Q28A7CQOGOFHFAnvcunSVWd',
						number: '1020个QIUI币',
						numberEn: '1020 QIUI coins',
						price: "169 USD",
					}

				]
			},
			payment(index) { //支付
				this.isDataLoading = true;
				const requestData = {};
				if (this.$p_url.includes('192.168')) {
					//测试环境
					requestData.priceId = this.tableData[index].priceId; //在Stripe平台定义好的商品的价格id
				} else {
					//正式环境
					requestData.priceId = this.tableData[index].priceId_formal; //在Stripe平台定义好的商品的价格id
				}
				requestData.userId = this.data.userId;


				console.log("支付传递给后台的数据：", requestData)
				axios.post(this.$p_url + '/feign/stripe/createCheckOutSession', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.isDataLoading = false;
						console.log("支付数据返回：", response.data)
						const state = response.data.state; // 获取状态
						// if (state === "authFailed") { //登录失效
						// 	Cookies.remove("token");
						// 	this.$router.push({ //跳转到登录
						// 		path: '/',
						// 		query: {}
						// 	});
						// }
						if (state === "success") { // 检查状态
							console.log("url：", response.data.data.url);
							window.open(response.data.data.url, '_blank');
						}
					})
					.catch(error => { // 请求失败时处理错误
						console.error('Error fetching data:', error);
					});

			},
			indexMethod(index) {
				return index + 1; // 返回行号
			},
			//...
		},
		//...
	}
</script>

<style scoped>

</style>